export const DEFAULT_SECTION_ID = "default-section";
